module.exports = __webpack_public_path__ + "media/svg-new/login 1-7cf0f929.svg";